import React from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

import Typography from '@material-ui/core/Typography';
import { ResponsiveCardImg } from 'components/ResponsiveImg';

import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
dayjs.extend(duration);

const TitleTypography = styled(Typography)`
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
  margin-top: ${props => (props.gutterTop ? '0.5em' : 0)};
`;

const PodcastItemWrapper = styled.article`
  width: 100%;
  ${props =>
    props.small &&
    css`
      display: flex;
      align-items: center;
      ${PodcastItemImg} {
        width: 100px;
        margin-right: 12px;
      }
    `}
`;

const PodcastItemImg = styled(ResponsiveCardImg)`
  border-radius: 5px;
  margin-bottom: 8px;
  background-color: rgba(255, 255, 255, 0.1);
  @supports (object-fit: cover) {
    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
  }
`;

const PodcastMeta = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 8px 0;
`;

const MetaTypography = styled(Typography)`
  opacity: 0.65;
`;

const PodcastItem = ({ episode, small, ...other }) => (
  <PodcastItemWrapper small={small} {...other}>
    <Link to={episode?.url}>
      {episode.cover_image ? (
        <PodcastItemImg
          src={episode.cover_image.url}
          alt={episode.title}
          maxWidth={320}
          square={episode?.type !== 'video'}
        />
      ) : (
        <PodcastItemImg alt="Placeholder" square={episode?.type !== 'video'} />
      )}
    </Link>
    <div>
      <PodcastMeta>
        <Typography variant="overline">
          {episode.episode_number ? (
            <> Episode {episode.episode_number}</>
          ) : (
            <>{episode.type}</>
          )}
        </Typography>
        <MetaTypography variant="overline">
          {dayjs
            .duration(episode.duration, 'seconds')
            .format(episode.duration < 3600 ? 'mm:ss' : 'H:mm:ss')}
        </MetaTypography>
      </PodcastMeta>
      <TitleTypography
        component={Link}
        to={episode.url}
        gutterBottom
        variant={small ? 'h6' : 'h5'}
      >
        {episode.title}
      </TitleTypography>
    </div>
  </PodcastItemWrapper>
);

export default PodcastItem;
